import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {DialogCloseResult, DialogRef, DialogService} from '@progress/kendo-angular-dialog';
import {DateUtils} from '../../date-utils';

@Component({
    selector: 'app-filter-date-range',
    templateUrl: './filter-date-range.component.html',
    styleUrls: ['./filter-date-range.component.scss']
})
export class FilterDateRangeComponent implements OnChanges {
    @Input() startDate: Date | null;
    @Input() endDate: Date | null;
    @Input() minDate: Date | null = null;
    @Input() popupSettings: any;
    /** Emits null when the picker is cleared. */
    @Output() startDateChange = new EventEmitter<Date | null>();
    @Output() endDateChange = new EventEmitter<Date | null>();

    public startDateRange: number;
    public endDateRange: number;

    constructor(private dialogService: DialogService) {
    }

    /** Day 0 for the days-out boxes: minDate when given, so it always shows as 0; otherwise today. */
    private get today(): Date {
        return this.minDate ?? new Date();
    }

    ngOnChanges(): void {
        this.startDateRange = this.startDate ? DateUtils.daysDiff(this.today, this.startDate) : undefined;
        this.endDateRange = this.endDate ? DateUtils.daysDiff(this.today, this.endDate) : undefined;
    }

    onStartDateChange(newDt: Date | null): void {
        if (!newDt) {
            // A cleared picker is passed up as null so the parent stops searching the old date.
            this.startDate = null;
            this.startDateRange = undefined;
            this.startDateChange.emit(null);
            return;
        }
        this.startDate = newDt;
        this.startDateRange = DateUtils.daysDiff(this.today, newDt);
        this.startDateChange.emit(newDt);
        if (!this.endDate || newDt > this.endDate) {
            this.setEndDate(newDt);
        }
    }

    onEndDateChange(newDt: Date | null): void {
        if (!newDt) {
            this.setEndDate(null);
            return;
        }
        if (this.startDate && newDt < this.startDate) {
            this.showInvalidEndDate();
            return;
        }
        this.setEndDate(newDt);
    }

    onStartDateRangeChange(newVal: number): void {
        if (newVal === null || newVal === undefined) {
            return;
        }
        this.onStartDateChange(DateUtils.addDays(this.today, newVal));
    }

    onEndDateRangeChange(newVal: number): void {
        if (newVal === null || newVal === undefined) {
            return;
        }
        this.onEndDateChange(DateUtils.addDays(this.today, newVal));
    }

    private setEndDate(newDt: Date | null): void {
        this.endDate = newDt;
        this.endDateRange = newDt ? DateUtils.daysDiff(this.today, newDt) : undefined;
        this.endDateChange.emit(newDt);
    }

    private showInvalidEndDate(): void {
        const dialog: DialogRef = this.dialogService.open({
            title: 'Invalid End Date !!!',
            content: 'End Date cannot be prior to Start Date.',
            actions: [
                {text: 'OK', primary: true}
            ]
        });
        dialog.result.subscribe((result) => {
            if ((result instanceof DialogCloseResult) || (result.text === 'OK')) {
                this.setEndDate(this.startDate);
            }
        });
    }
}
